import React from "react";
import PropTypes from "prop-types";
import { get, chunk } from "lodash";
import { LazyCollection, wrapCollectionLayout, LoadMoreCollectionStories } from "@quintype/components";
import Iframe from "react-iframe";
import { addAdsToTemplates } from "../../get-collection-template";
import BreadCrumb from "../story/story-templates/shared/breadcrumbs";
import FiveStoryOneAdOneWidget from "../../rows/five-story-one-ad-one-widget";
import NineteenStoriesOneAd from "../../rows/nineteen-stories-one-ad";
import SecondaryMenu from "../../atoms/secondary-menu";
import { LoadMoreButton } from "../../atoms/read-more-link";
import CollectionBannerImage from "../../atoms/collection-banner";
import { GA, WebEngage, DeepBI, EVOLOK, PGAD } from "../../../integrations";
import styles from "./styles.m.css";
import { DfpAd } from "../../atoms/dfp-ad";
import Media from "react-media";
import TnLocalElectionResult from "../../rows/tn-local-election-result";
import { VikatanSticky } from "../../rows/ad-free";
const LOAD_MORE_TEXT = "மேலும் படிக்க";

const newTemplates = addAdsToTemplates("section");
function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

const wrapForLoadMore = (Component, numberOfStoriesItCanAccomodate) => {
  const WrapperForLoadMore = ({ stories, collection, onLoadMore, noMoreStories, loading }) => {
    return (
      <React.Fragment>
        {chunk(stories.slice(5), numberOfStoriesItCanAccomodate).map((stories, index) => {
          const items = stories.map(story => {
            return { id: story.id, type: "story", story };
          });
          return <Component key={index} collection={{ ...collection, items }} pagetype="section" />;
        })}
        {!noMoreStories &&
          stories.length > numberOfStoriesItCanAccomodate && (
            <div className={styles["load-more-button-wrapper"]}>
              <LoadMoreButton onClick={onLoadMore} disabled={loading} text={LOAD_MORE_TEXT} />
            </div>
          )}
        <DfpAd
          className={`${styles["footer-ad"]} hidden-mobile`}
          adtype="Vikatan_Desktop_SP_BTF1_728x90"
          placement="section"
        />
      </React.Fragment>
    );
  };
  WrapperForLoadMore.propTypes = {
    stories: PropTypes.array,
    collection: PropTypes.object,
    onLoadMore: PropTypes.func,
    noMoreStories: PropTypes.func,
    loading: PropTypes.bool
  };
  return WrapperForLoadMore;
};

function shouldShowCollectionLayout(collection) {
  const firstCollection = get(collection, ["items"], []).find(item => item.type === "collection");
  return !!firstCollection;
}

export class SectionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      random: 0
    };
  }
  componentDidMount() {
    const sections = [this.props.data.section];
    if (this.props.data.parentSection) {
      sections.unshift(this.props.data.parentSection);
    }
    GA.registerPageView(this.props.pageType, { section: this.props.data.section });
    WebEngage.registerPageView({ section: this.props.data.section });
    EVOLOK.loadScript(this.props.pageType, { collection: this.props });
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();
  }

  render() {
    const stories = get(this.props.data, ["collection", "items"], []);

    const sectionSlug = get(this.props.data, ["collection", "slug"], "");
    const section = get(this.props.data, ["section"], {});
    const sectionName = get(this.props.data, ["section", "display-name"], "");
    const collectionName = get(this.props.data, ["collection", "name"], "");
    const sectionMenu = get(this.props.data, ["menuData"], null);
    const sectionColor = get(section, ["data", "color"]);
    const pageType = get(this.props, ["pageType"], null);

    if (stories.length < 1) {
      return (
        <div className={styles["default-section-page"]}>
          <div className={styles["no-stories"]}>
            <h2 className={styles["no-stories-status"]}>No stories found.</h2>
          </div>
        </div>
      );
    }
    if (shouldShowCollectionLayout(this.props.data.collection)) {
      const collectionItems = get(this.props.data, ["collection", "items"], []).filter(
        items => items.type === "collection"
      );
      const collection = { ...this.props.data.collection, items: [...collectionItems] };
      return (
        <div className={`${styles["default-section-page"]} ${styles["default-section-page-container"]}`}>
          {sectionMenu ? (
            <SecondaryMenu
              communityColor={sectionMenu["menuBgColor"] || sectionColor}
              menuGroup={sectionMenu}
              slug={sectionMenu["slug"] || sectionSlug}
            />
          ) : null}
          <div className={"container"}>
            {!Object.keys(section).length && Object.keys(collection).length ? (
              <BreadCrumb config={this.props.config} collection={collection} />
            ) : (
              <BreadCrumb config={this.props.config} subSection={section} />
            )}
          </div>
          {sectionName || collectionName ? (
            <div className="container">
              <h1 className={styles["headline"]}>{sectionName || collectionName}</h1>
            </div>
          ) : null}
          <LazyCollection
            collection={collection}
            collectionTemplates={getAdsWrappedCollectionTemplate}
            lazyAfter={4}
            accentColor={sectionColor}
            pageType={pageType}
          />
        </div>
      );
    }
    const initialStories = get(this.props.data, ["collection", "items"], []).filter(items => items.type === "story");
    const WrappedFiveStoryOneAdOneWidget = wrapCollectionLayout(FiveStoryOneAdOneWidget);
    return (
      <div className={`main-page ${styles["default-section-page-container"]}`}>
        <div />
        <div className={styles["default-section-page"]}>
          {sectionMenu ? (
            <SecondaryMenu
              communityColor={sectionMenu["menuBgColor"] || sectionColor}
              menuGroup={sectionMenu}
              slug={sectionMenu["slug"] || sectionSlug}
            />
          ) : null}
          <div className={"container"}>
            {this.props.data.section ? (
              <BreadCrumb config={this.props.config} subSection={this.props.data.section} />
            ) : (
              <BreadCrumb config={this.props.config} collection={this.props.data.collection} />
            )}
          </div>
          {sectionSlug === "union-budget-2022-highlights-and-updates" ? (
            <div className={`${styles["union-budget-container"]} container`}>
              <img
                className={`${styles["union-budget"]}`}
                src="https://gumlet.assettype.com/vikatan/2022-01/730ffb97-12c8-465e-9567-9af75fcb197a/Union_budget_2022_banner2.png"
              />
              <h1 className={`${styles["union-budget-text"]}`}>
                <span>யூனியன் பட்ஜெட்</span>
                <span>2022</span>
              </h1>
            </div>
          ) : null}

          {sectionSlug === "myvikatan" ? (
            <div className={`${styles["union-budget-container"]} container`}>
              <img
                className={`${styles["union-budget"]}`}
                src="https://gumlet.assettype.com/vikatan/2022-03/3bf21149-8652-4976-be72-fd59317810de/My_vikatan_collection_page_topbanner.png"
              />
            </div>
          ) : null}

          {sectionSlug === "ponniyin-selvan-podcast" ? (
            <div className={`${styles["union-budget-container"]} container`}>
              <img
                className={`${styles["union-budget"]}`}
                src="https://gumlet.assettype.com/vikatan/2022-09/16b3a9de-b73a-4306-a167-028a1e366159/a_L_o__M_.png"
              />
            </div>
          ) : null}

          {sectionSlug === "tamilnadu-urban-local-body-polls-2022-updates" ? (
            <div className={`${styles["election-header"]} container`}>
              <div className={styles["elction-header-image"]}>
                <img src="https://gumlet.assettype.com/vikatan/2022-02/98d4447b-bf45-4ffc-8c25-b9dcfd70e6bf/local_body_election_banner.png" />
              </div>

              <Media query="(min-width: 767px)">
                {matches =>
                  matches ? (
                    <div className={`${styles["iframe-author"]} hidden-mobile`}>
                      <Iframe
                        url="https://special.vikatan.com/tn-local-election-2022/overall-count.php"
                        width="364px"
                        height="160px"
                        frameBorder="0"
                        className={`${styles["iframe-overall-count"]} hidden-mobile`}
                      />
                    </div>
                  ) : null
                }
              </Media>
            </div>
          ) : null}
          {sectionSlug === "tamilnadu-urban-local-body-polls-2022-updates" ? (
            <div className={`${styles["florish-chart-grid"]} container`}>
              <TnLocalElectionResult />

              <Media query="(max-width: 767px)">
                {matches =>
                  matches ? (
                    <div className={`${styles["iframe-author"]} hidden-desktop `}>
                      <Iframe
                        url="https://special.vikatan.com/tn-local-election-2022/overall-count.php"
                        width="100%"
                        height="160px"
                        frameBorder="0"
                        className={`${styles["iframe-overall-count"]} hidden-desktop`}
                      />
                    </div>
                  ) : null
                }
              </Media>
              <DfpAd
                className="hidden-mobile ad-tower-right"
                adtype="Vikatan_Desktop_AP_ATF_RIGHT_300x250"
                placement="all"
              />
            </div>
          ) : null}

          {sectionSlug === "wedding-season-2021" ? (
            <CollectionBannerImage collection={this.props.data.collection} className={styles["collection-item"]} />
          ) : sectionName || collectionName ? (
            <div className="container">
              {sectionSlug !== "myvikatan" && <h1 className={styles["headline"]}>{sectionName || collectionName}</h1>}
            </div>
          ) : null}

          <WrappedFiveStoryOneAdOneWidget
            showReadmore={false}
            accentColor={sectionColor}
            collection={{ ...this.props.data.collection, items: initialStories.slice(0, 5) }}
            pagetype="section"
          />
          <LoadMoreCollectionStories
            template={wrapForLoadMore(NineteenStoriesOneAd, 19)}
            collectionSlug={this.props.data.collection.slug}
            data={Object.assign(
              {},
              { collection: this.props.data.collection },
              { stories: [...initialStories.map(({ story }) => story).slice(0, 24)] },
              { storiesPerPage: 19 }
            )}
            numStoriesToLoad={19}
            params={{ "item-type": "story" }}
          />
        </div>
        <div />
        <VikatanSticky placement="bundle" />
      </div>
    );
  }
}

SectionPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    section: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    }),
    parentSection: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    })
  }),
  config: PropTypes.shape({}),
  pageType: PropTypes.string
};
